import {
    get,
    post,
    put,
    del
} from './http'
const material = {
    // 添加素材
    addMaterial(params) {
        return post("client/material", params)
    },
     // 添加素材
     addLimitMaterial(params) {
        return post("client/material/addLimitMaterial", params)
    },
    // 删除素材
    delete(params) {
        return del("client/material/" + params.id)
    },
    //续期
    expired(params) {
        return put("client/material/expired/"+params.id)
    },
    //批量续期
    batchRenewal(){
        return get('client/material/batchRenewal')
    },
    // 获取素材分组
    getGroup() {
        return get("client/material/group/private")
    },
    // 行短阅信素材分组
    commonYueXinGroup() {
        return get("client/material/group/commonYueXinGroup")
    },
    // 获取公共素材分组
    getPublicGroup() {
        return get("client/material/group/public")
    },
    // 新增素材分组
    addGroup(params) {
        return post("client/material/group", params)
    },
    // 编辑用户分组
    editGroup(params) {
        return put("client/material/group", params)
    },
    // 删除用户分组
    delGroup(params) {
        return del(`client/material/group/${params}`)
    },
    // 编辑素材
    editMaterial(params) {
        return put("client/material", params)
    },
    upload(params) {
        return post("common/upload", params)
    },
    // 根据分组和文件类型获取素材列表
    getMaterialList(params, data) {
        let {
            groupId,
            resourceType,
        } = params
        return get(`client/material/group/${groupId}/type/${resourceType}`, data)
    },
     // 公共素材，根据分组和文件类型获取素材列表
     getMaterialPublic(params, data) {
        let {
            groupId,
            resourceType,
        } = params
        return get(`client/material/public/group/${groupId}/type/${resourceType}`, data)
    }


}

export default material
